import script from "./lang-toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./lang-toggle.vue?vue&type=script&setup=true&lang=ts"

import "./lang-toggle.vue?vue&type=style&index=0&id=e2c5a790&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2c5a790"]])

export default __exports__